import { createSelector } from '@ngrx/store';
import { AppState, PayformsFilterState } from '@app/state';

export const selectPayformsFilter = (state: AppState) => state.payformsFilter;

export const payformsFilterStateSelector = createSelector(selectPayformsFilter, (state: PayformsFilterState) => state);
